/* PhoneScreen · OTPScreen · LocationScreen */
import React, { useState, useEffect } from 'react';
import { C } from '../tokens.js';
import { Btn, OTPBox } from '../components/ui.jsx';
import { LOCATION_SUGGESTIONS, isServiceableCity, findCity } from '../lib/cities.js';

export const PhoneScreen = ({onNext}) => {
  const [phone,setPhone]=useState('');
  const [err,setErr]=useState('');
  const valid=/^\d{10}$/.test(phone);
  return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column',padding:'18px 28px 28px',background:C.bg}}>
      <div style={{marginBottom:32}}>
        <div style={{display:'flex',alignItems:'center',marginBottom:24}}>
          <img src="/grabioz-logo.png" alt="grabioz" style={{height:36,width:'auto',display:'block'}}/>
        </div>
        <h1 style={{fontSize:28,fontWeight:800,color:C.text,lineHeight:1.2,marginBottom:8}}>Enter your mobile number</h1>
        <p style={{fontSize:14,color:C.textMed,lineHeight:1.5}}>We'll send a one-time password to verify your number.</p>
      </div>
      <div style={{display:'flex',marginBottom:8,borderRadius:16,overflow:'hidden',border:`2px solid ${err?C.error:phone.length?C.primary:C.border}`,transition:'border .2s',background:C.white}}>
        <div style={{padding:'16px 14px',background:'#f5f5f4',borderRight:`1px solid ${C.border}`,display:'flex',alignItems:'center',gap:6,flexShrink:0}}>
          <span style={{fontSize:16}}>🇮🇳</span>
          <span style={{fontSize:15,fontWeight:700,color:C.text}}>+91</span>
        </div>
        <input value={phone} onChange={e=>{setPhone(e.target.value.replace(/\D/g,'').slice(0,10));setErr('');}}
          placeholder="98765 43210" inputMode="tel"
          style={{flex:1,padding:'16px 14px',border:'none',outline:'none',fontSize:18,fontWeight:700,color:C.text,letterSpacing:.5,background:'transparent'}}/>
      </div>
      {err&&<p style={{fontSize:12,color:C.error,marginBottom:8}}>{err}</p>}
      <p style={{fontSize:12,color:C.textMed,marginBottom:28}}>Standard SMS rates may apply.</p>
      <Btn full disabled={!valid} onClick={()=>{if(!valid){setErr('Enter a valid 10-digit mobile number.');return;}onNext(phone);}}>Send OTP →</Btn>
      <div style={{marginTop:'auto',padding:'24px 0 0',textAlign:'center'}}>
        <p style={{fontSize:12,color:C.textMed}}>By continuing, you agree to Rekraft's <span style={{color:C.primary,fontWeight:600}}>Terms</span> and <span style={{color:C.primary,fontWeight:600}}>Privacy Policy</span>.</p>
      </div>
    </div>
  );
};

export const OTPScreen = ({phone,onVerify,onBack}) => {
  const [timer,setTimer]=useState(30);
  const [err,setErr]=useState('');
  const [loading,setLoading]=useState(false);
  useEffect(()=>{if(timer<=0)return;const t=setInterval(()=>setTimer(v=>v-1),1000);return()=>clearInterval(t);},[timer]);
  const verify=(code)=>{
    if(loading)return; setLoading(true);
    setTimeout(()=>{
      if(code==='123456'){onVerify();}
      else if(code==='000000'){setErr('OTP expired. Request a new one.');setLoading(false);}
      else if(code==='999999'){setErr('Too many attempts. Try again in 10 minutes.');setLoading(false);}
      else{setErr('Incorrect OTP. Please try again.');setLoading(false);}
    },800);
  };
  const masked='+91 '+phone.slice(0,5).replace(/./g,'×')+' '+phone.slice(5);
  return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column',padding:'18px 28px 28px',background:C.bg}}>
      <button onClick={onBack} style={{alignSelf:'flex-start',background:'none',border:'none',color:C.primary,fontSize:14,fontWeight:700,cursor:'pointer',marginBottom:24,padding:0}}>← Back</button>
      <div style={{marginBottom:36}}>
        <h1 style={{fontSize:28,fontWeight:800,color:C.text,lineHeight:1.2,marginBottom:8}}>Verify your number</h1>
        <p style={{fontSize:14,color:C.textMed}}>OTP sent to <b style={{color:C.text}}>{masked}</b></p>
        <p style={{fontSize:12,color:C.textMed,marginTop:4}}>Demo: use <b style={{color:C.primary}}>123456</b></p>
      </div>
      <OTPBox onComplete={verify}/>
      {err&&<div style={{marginTop:16,padding:'12px 16px',background:C.errorBg,borderRadius:12,border:`1px solid ${C.error}`}}><p style={{fontSize:13,color:C.error,fontWeight:600}}>{err}</p></div>}
      {loading&&<p style={{textAlign:'center',marginTop:16,fontSize:14,color:C.textMed}}>Verifying…</p>}
      <div style={{marginTop:32,textAlign:'center'}}>
        {timer>0
          ?<p style={{fontSize:14,color:C.textMed}}>Resend in <b style={{color:C.text}}>{timer}s</b></p>
          :<button onClick={()=>{setTimer(30);setErr('');}} style={{background:'none',border:'none',color:C.primary,fontSize:14,fontWeight:700,cursor:'pointer'}}>Resend OTP</button>}
      </div>
    </div>
  );
};

export const LocationScreen = ({onSet}) => {
  const [search,setSearch]=useState('');
  const [loading,setLoading]=useState(false);
  const [selected,setSelected]=useState('');
  const [noSuppliers,setNoSuppliers]=useState(false);
  const [gpsError,setGpsError]=useState('');
  const [showSuggestions,setShowSuggestions]=useState(false);
  const filtered=search.length>1?LOCATION_SUGGESTIONS.filter(s=>s.toLowerCase().includes(search.toLowerCase())).slice(0,8):[];
  const pick=(loc)=>{
    // A picked suggestion is by construction one of LOCATION_SUGGESTIONS, so it's always serviceable.
    // Treat manually-typed text that doesn't match any launch city as out-of-zone.
    const looksLikeSuggestion = LOCATION_SUGGESTIONS.includes(loc);
    if (!looksLikeSuggestion && !isServiceableCity(loc)) { setNoSuppliers(true); setSelected(''); return; }
    setNoSuppliers(false); setSelected(loc);
  };
  const useGPS=()=>{
    setGpsError('');
    if(!('geolocation' in navigator)){setGpsError('Geolocation is not supported by this browser. Search manually below.');return;}
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (pos)=>{
        const {latitude,longitude}=pos.coords;
        // Reverse-geocode via OpenStreetMap Nominatim (no key needed; free, rate-limited).
        // Production should call a backend endpoint that uses a paid geocoder + checks serviceability in one shot.
        try{
          const res=await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=14&addressdetails=1`,{headers:{'Accept':'application/json'}});
          if(!res.ok) throw new Error('reverse-geocode failed');
          const data=await res.json();
          const a=data.address||{};
          const area=a.suburb||a.neighbourhood||a.locality||a.city_district||a.village||a.town||'';
          const city=a.city||a.town||a.state_district||a.state||'';
          // Prefer the canonical city name from our launch registry so the
          // UI label matches the alias-resolved record (e.g. "Bombay" → "Mumbai").
          const matched = findCity(city) || findCity(a.state_district) || findCity(data.display_name);
          const canonicalCity = matched ? matched.name : city;
          const label = [area, canonicalCity].filter(Boolean).join(', ')
            || (data.display_name ? String(data.display_name).split(',').slice(0,2).join(',').trim() : `${latitude.toFixed(3)}, ${longitude.toFixed(3)}`);
          if (matched) {
            setNoSuppliers(false); setSelected(label);
          } else {
            setNoSuppliers(true); setSelected('');
          }
        }catch(err){
          // Reverse-geocode failed — surface coords so the user can still confirm.
          setSelected(`${latitude.toFixed(3)}, ${longitude.toFixed(3)}`);
        }finally{
          setLoading(false);
        }
      },
      (err)=>{
        setLoading(false);
        if(err.code===err.PERMISSION_DENIED){
          setGpsError('Location permission denied. Enable it in your browser settings, or search manually below.');
        }else if(err.code===err.POSITION_UNAVAILABLE){
          setGpsError("Couldn't determine your location. Try again or search manually.");
        }else if(err.code===err.TIMEOUT){
          setGpsError('Location request timed out. Try again or search manually.');
        }else{
          setGpsError('Something went wrong getting your location. Search manually below.');
        }
      },
      { enableHighAccuracy:false, timeout:10000, maximumAge:5*60*1000 },
    );
  };
  return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column',padding:'18px 28px 28px',background:C.bg}}>
      <div style={{marginBottom:26}}>
        <div style={{display:'flex',alignItems:'center',marginBottom:22}}>
          <img src="/grabioz-logo.png" alt="grabioz" style={{height:32,width:'auto',display:'block'}}/>
        </div>
        <h1 style={{fontSize:24,fontWeight:800,color:C.text,marginBottom:8}}>Set your delivery area</h1>
        <p style={{fontSize:14,color:C.textMed}}>We'll show suppliers available in your zone.</p>
      </div>
      <button onClick={useGPS} disabled={loading} style={{display:'flex',alignItems:'center',gap:12,padding:'16px 20px',borderRadius:16,border:`2px solid ${C.primary}`,background:'#e6f7fb',cursor:loading?'wait':'pointer',marginBottom:gpsError?12:20,width:'100%'}}>
        <div style={{width:40,height:40,borderRadius:10,background:C.primary,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="3" stroke="white" strokeWidth="2"/><path d="M10 2v2M10 16v2M2 10h2M16 10h2" stroke="white" strokeWidth="2" strokeLinecap="round"/></svg>
        </div>
        <div style={{textAlign:'left',flex:1,minWidth:0}}>
          <p style={{fontSize:14,fontWeight:700,color:C.primary}}>{loading?'Detecting your location…':'Use my current location'}</p>
          <p style={{fontSize:12,color:C.textMed}}>{loading?'Browser will ask for permission':'Browser geolocation'}</p>
        </div>
      </button>
      {gpsError&&(
        <div style={{padding:'12px 14px',background:C.warningBg,borderRadius:12,border:`1px solid #fde68a`,marginBottom:20,display:'flex',gap:10,alignItems:'flex-start'}}>
          <span style={{fontSize:14,lineHeight:1.2}}>⚠️</span>
          <p style={{fontSize:12,color:'#92400e',lineHeight:1.45,flex:1}}>{gpsError}</p>
        </div>
      )}
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:20}}><div style={{flex:1,height:1,background:C.border}}/><span style={{fontSize:13,color:C.textMed,fontWeight:600}}>or</span><div style={{flex:1,height:1,background:C.border}}/></div>
      <div style={{position:'relative',marginBottom:12}}>
        <input value={search} onChange={e=>{setSearch(e.target.value);setNoSuppliers(false);setShowSuggestions(true);}} onFocus={()=>{if(search.length>1&&search!==selected)setShowSuggestions(true);}} placeholder="Search your area or pin code…"
          style={{width:'100%',padding:'14px 16px',borderRadius:14,border:`1.5px solid ${search?C.primary:C.border}`,outline:'none',fontSize:14,color:C.text,background:C.white}}/>
        {showSuggestions&&filtered.length>0&&<div style={{position:'absolute',top:'calc(100% + 4px)',left:0,right:0,background:C.white,borderRadius:14,border:`1px solid ${C.border}`,boxShadow:'0 8px 24px rgba(0,0,0,.12)',overflow:'hidden',zIndex:10}}>
          {filtered.map((s,i)=><button key={i} onClick={()=>{pick(s);setSearch(s);setShowSuggestions(false);}} style={{width:'100%',padding:'13px 16px',border:'none',background:'none',textAlign:'left',fontSize:14,color:C.text,cursor:'pointer',borderBottom:i<filtered.length-1?`1px solid ${C.border}`:'none',display:'flex',gap:10,alignItems:'center'}}>📍 {s}</button>)}
        </div>}
      </div>
      {noSuppliers&&<div style={{padding:'16px',background:C.errorBg,borderRadius:14,border:`1px solid ${C.error}`,marginBottom:16}}><p style={{fontSize:14,fontWeight:700,color:C.error,marginBottom:4}}>No suppliers in your area yet</p><p style={{fontSize:12,color:C.textMed}}>We're expanding fast. Leave your email to get notified.</p></div>}
      {selected&&<div style={{padding:'14px 16px',background:'#dcfce7',borderRadius:14,border:'1px solid #86efac',marginBottom:20,display:'flex',gap:10,alignItems:'center'}}><span>📍</span><div><p style={{fontSize:14,fontWeight:700,color:'#15803d'}}>{selected}</p><p style={{fontSize:12,color:'#16a34a'}}>Suppliers available in this area</p></div></div>}
      <div style={{marginTop:'auto'}}>
        <Btn full disabled={!selected||noSuppliers} onClick={()=>onSet(selected)}>Confirm area →</Btn>
      </div>
    </div>
  );
};
